import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { NoAccessesLeft } from '../NoAccessesLeft';
import { withLoadingFallback } from '../../../../hocs/withLoadingFallback';
import { PaymentStates } from '../PaymentStates';

const Suspended = withLoadingFallback(Fragment);

const TheoryAccessSellingPageComponent = ({
  hasRemainingAccesses, schoolPhone, isAccessesChecking, schoolName, cost, schoolId,
}) => (
  <Suspended isLoading={isAccessesChecking}>
    {
      hasRemainingAccesses
        ? <PaymentStates schoolName={schoolName} cost={cost} schoolId={schoolId} />
        : <NoAccessesLeft schoolPhone={schoolPhone} />
    }
  </Suspended>
);

TheoryAccessSellingPageComponent.propTypes = {
  hasRemainingAccesses: PropTypes.bool.isRequired,
  schoolPhone: PropTypes.string.isRequired,
  schoolName: PropTypes.string.isRequired,
  isAccessesChecking: PropTypes.bool.isRequired,
  cost: PropTypes.string.isRequired,
  schoolId: PropTypes.string.isRequired,
};

export { TheoryAccessSellingPageComponent };
